import { ResponseService } from './../services/response.service';
import { BreadcrumbsService } from './../services/breadcrumbs.service';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { NotificationsService } from 'angular2-notifications';
import { Router } from '@angular/router';
import { ApiService } from './../services/api.service';
import { CustomValidators } from 'ng2-validation';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { FormService } from './../services/form.service';


@Component({
  selector: 'app-main',
  templateUrl: './remind.component.html',
})
export class RemindComponent implements OnInit {
  public remindPasswordForm: FormGroup;
  public loading: Boolean = false;

  constructor(
    private apiService: ApiService,
    private router: Router,
    private notificationsService: NotificationsService,
    private translateService: TranslateService,
    private breadcrumbsService: BreadcrumbsService,
    private responseService: ResponseService,
    private formService: FormService
  ) { 

    const controls = {
      email: new FormControl('')
    };

    const validators = {
      email: [Validators.required, CustomValidators.email]
    };

    this.remindPasswordForm = this.formService.buildForm(controls, validators);
  }

  ngOnInit() {}

  remind(): void {
    this.loading = true;
    this.apiService.post('/password/email', this.remindPasswordForm.value).subscribe(
      (response) => {
        this.responseService.success(true, response);
        this.router.navigateByUrl('/login');
      },
      (error) => {
        this.responseService.error(error, this.remindPasswordForm);
        this.loading = false;
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/login/remind.component.ts